module.exports = __webpack_public_path__ + "components/app-promo/static/background-app-page-893945917ffdfe06cf44aa07ef118ea2.jpg";